<template>
    <b-card no-body>
        <b-card-header>
            <span class="h5">
                CONTRATO -
                <strong>
                    {{ contrato.vcCodigoEstruturado }} -
                    {{ contrato.fornecedor ? contrato.fornecedor.nome : '' }}
                </strong>
                <b-badge variant="warning" class="ml-2">{{ operacao }}</b-badge>
            </span>
        </b-card-header>
        <b-card-body>
            <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Tipo Contrato RM</label>
                        <b-form-select
                            :options="tiposContratoRm"
                            v-model="tipoContratoRm.codigo"
                            text-field="descricao"
                            value-field="codigo"
                            @input="$v.tipoContratoRm.codigo.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <!-- <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Status Contrato RM</label>
                        <b-form-select
                            :options="statusContratoRm"
                            v-model="codStatusContratoRm"
                            text-field="descricao"
                            value-field="codigo"
                            @input="$v.codStatusContratoRm.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col> -->
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Tipo para Faturamento RM</label>
                        <b-form-select
                            :options="tiposProdutosFaturamentoRm"
                            v-model="tipoProdutoFaturamentoRm.codigo"
                            text-field="descricao"
                            value-field="codigo"
                            @input="$v.tipoProdutoFaturamentoRm.codigo.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Natureza</label>
                        <model-list-select
                            :list="tiposNatureza"
                            option-text="descricao"
                            option-value="codigo"
                            v-model="tipoNatureza.codigo"
                            @input="$v.tipoNatureza.codigo.$touch()"
                        >
                        </model-list-select>
                    </b-form-group>
                </b-col>
                <!-- <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Condição de pagamento RM</label>
                        <b-form-select
                            :options="condicoesPagamentoRm"
                            v-model="codCondicaoPagamentoRm"
                            text-field="nome"
                            value-field="codigo"
                            @input="$v.codCondicaoPagamentoRm.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col> -->
                <!-- </b-row>
            <b-row> -->
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Tipo do Movimento</label>
                        <b-form-select
                            :options="tipoMovimentoOptions"
                            v-model="tipoMovimento"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Gestor do contrato</label>
                        <b-form-select
                            :options="vendedores"
                            v-model="gestorContrato.codigo"
                            text-field="nome"
                            value-field="codigo"
                            @input="$v.gestorContrato.codigo.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Gerente do gestor</label>
                        <b-form-select
                            :options="vendedores"
                            v-model="gerenteGestor.codigo"
                            text-field="nome"
                            value-field="codigo"
                            @input="$v.gerenteGestor.codigo.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Representante</label>
                        <model-list-select
                            :list="representantes"
                            option-text="nome"
                            option-value="codigo"
                            v-model="representante.codigo"
                            @input="$v.representante.codigo.$touch()"
                        >
                        </model-list-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Tipos de movimentos adicionais</label>
                        <multi-select
                        :options="tiposMovimentosAdicionaisOptions"
                        :selected-options="tiposMovimentosAdicionaisSelecionados"
                        @select="selecionarTipoMovimentoAdc"
                        ></multi-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="alteraGestor || alteraGerente">
                <b-col sm="3">
                    <b-form-group>
                        <label>Justificativa de alteração</label>
                        <b-form-textarea
                            v-model="justificativaGestor"
                            :rows="2"
                            @input.native="
                                $v.justificativaGestor.$touch()
                            "
                            :state="
                                $v.justificativaGestor.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card-body>
        <b-card-footer>
            <b-button variant="danger" @click.stop="voltar()" class="mr-1">
                <span> <i class="fa fa-history"></i> Cancelar </span>
            </b-button>
            <b-button
                variant="primary"
                :disabled="desabilitarBtnSalvar"
                @click.stop="confirmaSalvar()"
            >
                <i class="fa fa-save"></i> Salvar
            </b-button>
        </b-card-footer>
    </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ContratoRmServicos from '../../rm/ContratosRMServicos'
import ContratosServicos from '../ContratosServicos'
import { ModelListSelect } from 'vue-search-select'
import { MultiSelect } from 'vue-search-select'

export default {
    components: {
        ModelListSelect,
        MultiSelect
    },

    data() {
        return {
            id: '',
            contrato: {},
            tiposContratoRm: [],
            tipoContratoRm: {
                codigo: '',
                descricao: ''
            },
            tiposProdutosFaturamentoRm: [],
            tipoProdutoFaturamentoRm: {
                codigo: '',
                descricao: ''
            },
            tiposNatureza: [],
            tipoNatureza: {
                codigo: '',
                descricao: ''
            },
            vendedores: [],
            gestorContrato: {
                codigo: '',
                nome: ''
            },
            gestorAtual: null,
            justificativaGestor: '',
            gerenteGestor: {
                codigo: '',
                nome: ''
            },
            gerenteAtual: null,
            representantes: [],
            representante: {
                codigo: '',
                nome: ''
            },
            erros: [],
            operacao: 'ATUALIZAR',
            tipoMovimentoOptions: [],
            tipoMovimento: '1.1.80',
            tiposMovimentosAdicionais: [],
            tiposMovimentosAdicionaisSelecionados: []
        }
    },
    methods: {
        obterTiposContrato() {
            this.$store.dispatch('addRequest')
            ContratoRmServicos.obterTiposContrato().then(response => {
                if (response) {
                    if (response.success) {
                        this.tiposContratoRm = response.data
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterInformacoesContrato() {
            this.$store.dispatch('addRequest')
            ContratoRmServicos.obterInformacoesComplementaresContratoRM().then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.statusContratoRm =
                                response.data.statusContratoRMDto
                            this.tiposContratoRm =
                                response.data.tiposContratoRMDto
                            this.tiposProdutosFaturamentoRm =
                                response.data.tiposProdutoFaturamentoRmDto
                            this.condicoesPagamentoRm =
                                response.data.condicoesPagamentoRMDto
                            this.tiposNatureza = response.data.tiposNaturezaDto
                            this.vendedores = response.data.vendedoresRMDto
                            this.representantes =
                                response.data.representantesRMDto
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterTiposMovimentos() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterTiposMovimentos().then(response => {
                if (response) {
                    if (response.success) {
                        this.tipoMovimentoOptions = response.data
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        buscaElemento(colecao, elementoCod) {
            return colecao.find(x => x.codigo == elementoCod)
        },

        confirmaSalvar() {
            this.$store.dispatch('addRequest')
            this.tipoContratoRm = this.buscaElemento(
                this.tiposContratoRm,
                this.tipoContratoRm.codigo
            )
            this.tipoProdutoFaturamentoRm = this.buscaElemento(
                this.tiposProdutosFaturamentoRm,
                this.tipoProdutoFaturamentoRm.codigo
            )
            this.tipoNatureza = this.buscaElemento(
                this.tiposNatureza,
                this.tipoNatureza.codigo
            )
            this.gestorContrato = this.buscaElemento(
                this.vendedores,
                this.gestorContrato.codigo
            )
            this.gerenteGestor = this.buscaElemento(
                this.vendedores,
                this.gerenteGestor.codigo
            )
            this.representante = this.buscaElemento(
                this.representantes,
                this.representante.codigo
            )

            let dadosRmDto = {
                id: this.id,
                contratoId: this.$route.params.contratoId,
                tipoContratoRMDto: this.tipoContratoRm,
                tipoProdutoFaturamentoRmDto: this.tipoProdutoFaturamentoRm,
                tipoNaturezaDto: this.tipoNatureza,
                gestorContrato: this.gestorContrato,
                justificativaGestor: this.justificativaGestor,
                gerenteGestor: this.gerenteGestor,
                representanteRMDto: this.representante,
                tipoMovimento: this.tipoMovimento,
                tiposMovimentosAdicionais: this.tiposMovimentosAdicionais
            }

            ContratoRmServicos.inserirDadosRm(dadosRmDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Dados do RM inseridos com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.voltar()
                    } else {
                        this.erros = response.errors 
                    }
                }
                this.$store.dispatch('removeRequest')       
            })
        },

        preencheForm(dadosContratoRM) {
            this.id = dadosContratoRM.id
            this.tipoContratoRm.codigo =
                dadosContratoRM.tipoContratoRMDto.codigo
            this.tipoProdutoFaturamentoRm.codigo =
                dadosContratoRM.tipoProdutoFaturamentoRmDto.codigo
            this.tipoNatureza.codigo = dadosContratoRM.tipoNaturezaDto.codigo
            this.gestorContrato.codigo = dadosContratoRM.gestorContrato.codigo
            this.gestorAtual = dadosContratoRM.gestorContrato.codigo
            this.gerenteGestor.codigo = dadosContratoRM.gerenteGestor.codigo
            this.gerenteAtual = dadosContratoRM.gerenteGestor.codigo
            this.representante.codigo =
                dadosContratoRM.representanteRMDto.codigo
            this.tipoMovimento = dadosContratoRM.tipoMovimento
            this.tiposMovimentosAdicionais = dadosContratoRM.tiposMovimentosAdicionais
            this.ajustarMovimentosAdicionaisCarga()
        },

        obterDadosRM() {
            ContratoRmServicos.obterDadosContratoRM(
                this.$route.params.contratoId
            ).then(response => {
                if (response) {
                    if (response.success && response.data != null) {
                        this.preencheForm(response.data)
                    }
                }
            })
        },

        voltar() {
            this.erros = []
            this.$router.push({
                name: 'Contratos_Detalhar',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        selecionarTipoMovimentoAdc(tipos) {
            this.tiposMovimentosAdicionaisSelecionados = tipos
            this.ajustarMovimentosAdicionaisSelecionados()
        },

        ajustarMovimentosAdicionaisSelecionados() {
            this.tiposMovimentosAdicionaisSelecionados = this.tiposMovimentosAdicionaisSelecionados.filter(tipo => {
                return tipo.value != this.tipoMovimento
            })
            this.tiposMovimentosAdicionais = this.tiposMovimentosAdicionaisSelecionados.map(tipo => tipo.value)
        },

        ajustarMovimentosAdicionaisCarga() {
            if (this.tiposMovimentosAdicionais != null) {
                this.tiposMovimentosAdicionais.forEach(m => {
                    this.tiposMovimentosAdicionaisSelecionados.push({
                        value: m,
                        text: m
                    })
                })
            }
        }
    },

    created() {
        this.obterInformacoesContrato()
        this.obterDadosRM()
        this.obterTiposMovimentos()
        //this.obterContrato()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        alteraGestor() {
            return (this.gestorAtual != null && this.gestorAtual != this.gestorContrato.codigo)
        },

        alteraGerente() {
            return (this.gerenteAtual != null && this.gerenteAtual != this.gerenteGestor.codigo)
        },

        tiposMovimentosAdicionaisOptions() {
            let tiposMovimentos = []
            this.tipoMovimentoOptions.forEach((m) => {
                if (m != this.tipoMovimento) {
                    tiposMovimentos.push({
                        value: m,
                        text: m
                    })
                }
            })
            return tiposMovimentos
        }
    },

    watch: {
        tipoMovimento() {
            if (this.tiposMovimentosAdicionais.includes(this.tipoMovimento)) {
                this.ajustarMovimentosAdicionaisSelecionados()
            }
        }
    },

    validations: {
        tipoContratoRm: {
            codigo: {
                required
            }
        },

        tipoProdutoFaturamentoRm: {
            codigo: {
                required
            }
        },

        tipoNatureza: {
            codigo: {
                required
            }
        },

        gestorContrato: {
            codigo: {
                required
            }
        },

        gerenteGestor: {
            codigo: {
                required
            }
        },

        representante: {
            codigo: {
                required
            }
        },

        tipoMovimento: {
            required
        },

        justificativaGestor: {
            alteracao() {
                if (this.alteraGestor || this.alteraGerente) {
                    return this.justificativaGestor != '' && this.justificativaGestor.length <= 250
                }
                return true
            }
        }
    }
}
</script>
